export const LOCALSTORAGE_KEYS = {
  customer: "CUSTOMERID",
  hvSubstation: "HVSUBSTATIONID",
  company: "COMPANYNAME",
  site: "SITENAME",
  hvSubstationSortField: "HVSUBSTATIONSORTFIELD",
  hvSubstationSortOrder: "HVSUBSTATIONSORTORDER",
  workflowsSortField: "WORKFLOWSSORTFIELD",
  workflowsSortOrder: "WORKFLOWSSORTORDER",
  workOrdersSortField: "WORKORDERSSORTFIELD",
  workOrdersSortOrder: "WORKORDERSSORTORDER",
  resultsSortField: "RESULTSSORTFIELD",
  resultsSortOrder: "RESULTSSORTORDER",
  companiesSortField: "COMPANIESSORTFIELD",
  companiesSortOrder: "COMPANIESSORTORDER",
  sitesSortField: "SITESSORTFIELD",
  sitesSortOrder: "SITESSORTORDER",
  userManagementSortField: "USERMANAGEMENTSORTFIELD",
  userManagementSortOrder: "USERMANAGEMENTSORTORDER",
  reportsSortField: "REPORTSSORTFIELD",
  reportsSortOrder: "REPORTSSORTORDER",
  generatedReportsSortField: "GENERATEDREPORTSSORTFIELD",
  generatedReportsSortOrder: "GENERATEDREPORTSSORTORDER",
};
